import './App.css';
import React, { useState } from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { TimeLine } from './components/timeline/TimeLine';
import {
  Day1,
  Day2,
  Day3,
  Day4,
  Button1,
  Button2,
  Button3,
  Button4
} from './utils/timeLine-content';
import { BlockChainIntoduction } from './components/blockChainIntoduction/blockChainIntoduction';
import { MatimediaIntoduction } from './components/matimediaIntoduction/matimediaIntoduction';
import { SpeakerList } from './components/SpeakerList';
import { Biography } from './components/biography/index';

import zh from './locale/zh_CN';
import en from './locale/en_US';

function App() {
  const [language, setLanguage] = useState(en);
  const [languageName, setLanguageName] = useState('en');

  const chooseLanguage = (props) => {
    if (props === 'Chinese') {
      document.title = '区块链和多媒体数据科学(BMDS)研讨会';
      setLanguage(zh);
      setLanguageName('zh');
    } else if (props === 'English') {
      document.title = 'BMDS Seminar';
      setLanguage(en);
      setLanguageName('en');
    }
  };

  return (
    <IntlProvider locale={'en'} messages={language}>
      <div className="App">
        <div className="background">
          <div className="Blockchain">
            <div className="App-header">
              <div className="img5">
                <a
                  href="https://www.ualberta.ca/index.html"
                  alt="alberta"
                  target="view_window">
                  <img
                    className="img-item1"
                    src="./img/image5.png"
                    alt="image5"
                  />
                  <img
                    className="img-item2"
                    src="./img/logo41x.png"
                    alt="image5"
                  />
                </a>
              </div>
              <div className="img4">
                <a
                  href="https://mrc.science.ualberta.ca/bmds2021/"
                  alt="science"
                  target="view_window">
                  <img
                    className="img-item1"
                    src="./img/image 4.png"
                    alt="image4"
                  />
                  <img
                    className="img-item2"
                    src="./img/logo31x.png"
                    alt="image4"
                  />
                </a>
              </div>
              <div className="img3">
                <a
                  href="https://mrc.science.ualberta.ca/bmds2021/program/ "
                  alt="multimedia-program"
                  target="view_window">
                  <img
                    className="img-item1"
                    src="./img/image3.png"
                    alt="image3"
                  />
                  <img
                    className="img-item2"
                    src="./img/logo21x.png"
                    alt="image3"
                  />
                </a>
              </div>
              <div className="img2">
                <a
                  href="https://whitematrix.io/"
                  alt="whitematrix"
                  target="view_window">
                  <img
                    className="img-item1"
                    src="./img/image2.png"
                    alt="image2"
                  />
                  <img
                    className="img-item2"
                    src="./img/logo11x.png"
                    alt="image2"
                  />
                </a>
              </div>
              <div className="language-switch">
                {languageName === 'en' && (
                  <span onClick={() => chooseLanguage('Chinese')}>中文</span>
                )}
                {languageName === 'zh' && (
                  <span onClick={() => chooseLanguage('English')}>English</span>
                )}
              </div>
              <div className="Language">
                <div className="Language-item">
                  <div className="text">
                    <FormattedMessage id="Language" />
                  </div>
                  <div className="dropBtn">
                    <img src="./img/Stroke 2.png" alt="dropBtn" />
                  </div>
                </div>
                <div className="select">
                  <ul>
                    <li onClick={() => chooseLanguage('Chinese')}>
                      <FormattedMessage id="Chinese" />
                    </li>
                    <li onClick={() => chooseLanguage('English')}>
                      <FormattedMessage id="English" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <div className="font1">
                <FormattedMessage id="welcome" />
              </div>
              <div className="font2">
                <FormattedMessage id="title" />
              </div>
              <div className="font3">
                <FormattedMessage id="sponsored" />
              </div>
              <div className="date">
                <FormattedMessage id="titleDate" />
              </div>
              <div className="Button" onClick={jump}>
                <button>
                  <FormattedMessage id="signUp" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div className="Content">
            <div className="content-item Content-Date">
              <div className="content-item-img">
                <img src="./img/编组 4.png" alt="Date" />
              </div>
              <div className="Content-text">
                <FormattedMessage id="date" />
              </div>
              <div className="Content-data">
                <>
                  <div>
                    <FormattedMessage id="Date1" />
                  </div>
                  <div>
                    <FormattedMessage id="Date2" />
                  </div>
                </>
              </div>
            </div>
            <div className="content-item Content-Duration">
              <div className="content-item-img">
                <img src="./img/编组 3.png" alt="Duration" />
              </div>
              <div className="Content-text">
                <FormattedMessage id="duration" />
              </div>
              <div className="Content-data">
                <>
                  <div>
                    <FormattedMessage id="Duration1" />
                  </div>
                  <div>
                    <FormattedMessage id="Duration2" />
                  </div>
                </>
              </div>
            </div>
            <div className="content-item Content-Event">
              <div className="content-item-img">
                <img src="./img/Fill 35.png" alt="Event" />
              </div>
              <div className="Content-text">
                <FormattedMessage id="event" />
              </div>
              <div className="Content-data">
                <>
                  <div>
                    <FormattedMessage id="Event1" />
                  </div>
                  <div>
                    <FormattedMessage id="Event2" />
                  </div>
                </>
              </div>
            </div>
            <div className="content-item Content-Speaker">
              <div className="content-item-img">
                <img src="./img/编组 2.png" alt="Speaker" />
              </div>
              <div className="Content-text">
                <FormattedMessage id="speaker" />
              </div>
              <div className="Content-data">
                <div>
                  <FormattedMessage id="Speaker1" />
                </div>
                <div>
                  <FormattedMessage id="Speaker2" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <BlockChainIntoduction />
        <MatimediaIntoduction />
        <SpeakerList />
        <Biography />
        <div className="Conference">
          <div className="Conference-item">
            <div className="TimelineA">
              <TimeLine
                conference={true}
                timeInformation={Day1}
                buttonInformation={Button1}
              />
              <TimeLine timeInformation={Day2} buttonInformation={Button2} />
              <TimeLine timeInformation={Day3} buttonInformation={Button3} />
              <TimeLine timeInformation={Day4} buttonInformation={Button4} />
            </div>
          </div>
        </div>
      </div>
    </IntlProvider>
  );

  function jump() {
    const local = Intl.DateTimeFormat().resolvedOptions().locale;
    if (local.includes('CN')) {
      window.open('https://www.wenjuan.com/s/UZBZJvs4l7/#');
    } else {
      window.open('https://forms.gle/cEczoLZ7ix1nsttN7');
    }
  }
}

export default App;
